module.exports = __webpack_public_path__ + "img/phoneImg2.a9f10588.jpg";